import {useEffect} from "react";
import {TASK_ACTIONS, DETAILS_VIEW_TYPE, LOADING_STATUS} from "utils/constants";
import {useDispatch, useSelector} from "react-redux";
import {taskAction} from "../mytasks/action/taskAction.action";
import {
    navigateBetweenProcessTasks,
} from "../mytasks/action/navigateBetweenTasks.action";
import {TaskDetailActions} from "../mytasks/AvailableActions.class";
import {
    getProcessAndHistoryComments,
    getProcessByUIDWithPermissions,
    handleAddProcessAndHistoryDraftCommentsByUID,
    removeSelectedDocument,
} from "../taskdetails-remake/taskDetails.action";
import {formatTaskDetailsTopBanner} from "utils/valueFormatter.function";
import {handleNPKeyNavigation} from "utils/keyPressHandler.function";
import _ from "lodash";
import {preventProcessReload} from "../processoverview/processOverview.action";
import TaskDetails from "components/taskdetails-remake/TaskDetails.component";
import {PATH_TO_PROCESS_OVERVIEW} from "components/router/paths.js";
import * as reduxSelectors from "components/store/application.reducers.js";
import { Loader, LoaderSize } from "components/common/Loader.component";
import {PanelErrorFallback} from "components/errorpage/PanelErrorBoundary";


const TaskDetailMasterLayerByUID = (props: any) => {

    const tasks = useSelector(reduxSelectors.getProcessOverviewTasks);
    const activeTask = useSelector(reduxSelectors.getActiveTask);
    const taskDetails = useSelector(reduxSelectors.getTaskDetails);
    const attachments = useSelector(reduxSelectors.getTaskAttachments);
    const loadingStatus = useSelector(reduxSelectors.getAttachmentsLoadingStatus);
    const dispatch = useDispatch();

    const routeUid = props.match.params.uid;
    // until the process arrives, fall back to the overview entry as the key route does, so moving between tasks keeps the page mounted
    const task = activeTask?.uid === routeUid
        ? activeTask
        : (tasks.allTasks || []).find((x: any) => x.uid === routeUid);

    useEffect(() => {
        dispatch(removeSelectedDocument());
        document.addEventListener("keydown", handleKeyPress);
        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, []);

    // the store's copy of the task has no attachments, so reload it; this runs on mount too, so it is the only request
    useEffect(() => {
        requestData(props.match.params.uid);
    }, [props.match.params.uid]);


    const taskNavigation = (uid: string, isForward: boolean) => {
        props.history(dispatch(navigateBetweenProcessTasks(uid, isForward)));
    };

    const handleKeyPress = (e) => {
        handleNPKeyNavigation(e, props.match.params.uid, taskNavigation);
    };

    const requestData = (uid: string) => {
        dispatch(getProcessByUIDWithPermissions(uid));
    };

    const navigateBack = () => {
        /*before going back to the Process overview set the prevent data reload to true
            - we need to scroll position to remain in place
        */
        preventProcessReload(true);
    };

    const getActionsForTask = (navigation) => {
        let activeActions = new TaskDetailActions();

        // add email
        activeActions.enable(TASK_ACTIONS.EMAIL);

        //check if move actions are available
        if (navigation.currentTask !== navigation.total) {
            //enable move to next
            activeActions.enable(TASK_ACTIONS.NEXT_TASK);
        }
        if (navigation.currentTask !== 1) {
            activeActions.enable(TASK_ACTIONS.PREVIOUS_TASK);
        }
        return activeActions;
    };

    const getNavigation = () => {
        //fill in all the data found in the task
        let response = formatTaskDetailsTopBanner(task, true);

        response.companyName = task?.companyName;
        //task number and number of selected tasks still need to be computed
        response.currentTask = _.findIndex(tasks.allTasks, (x => {
            // @ts-ignore
            return x.key === task?.key;
        })) + 1;
        response.total = tasks.allTasks ? tasks.allTasks.length : 0;
        return response;
    };

    const dispatchTaskAction = (type: any, taskIds = [], options = {}, navigate = () => {
    }) => {
        dispatch(taskAction(type, taskIds, {...options, navigate}));
    }

    const dispatchHandleAddProcessAndHistoryDraftCommentsByUID = (taskKey: string, comment: string, documentUid: string, uid: string) => {
        dispatch(handleAddProcessAndHistoryDraftCommentsByUID(taskKey, comment, documentUid, uid));
    }

    const dispatchGetProcessAndHistoryComments = (uid: string, taskId: string, skipLoading = false) => {
        dispatch(getProcessAndHistoryComments(uid, taskId, skipLoading));
    }

    const navigationData = getNavigation();
    const activeActions = getActionsForTask(navigationData);
    const params = {
        taskId: task?.key,
        uid: task?.uid,
    };
    // the store may still hold the previously opened task, so rendering it would fire the panel requests with its uid
    const isCurrentTask = task?.uid === routeUid;

    // a failed load leaves no task to render, so the spinner below would never resolve (AC-12773)
    if (loadingStatus === LOADING_STATUS.ERROR)
        return <PanelErrorFallback/>;

    return (
        <div>
            {!isCurrentTask ?
                <div className="position-fixed top-50 w-100">
                    <Loader size={LoaderSize.Medium} />
                </div> :
                // @ts-ignore
                <TaskDetails params={params}
                             task={task}
                             taskAction={dispatchTaskAction}
                             attachments={attachments}
                             loadingStatus={loadingStatus}
                             taskDetails={taskDetails}
                             navigation={navigationData}
                             route={props.route}
                             navigateBetweenTasks={taskNavigation}
                             activeActions={activeActions}
                             navigateBack={navigateBack}
                             navigateBackPath={PATH_TO_PROCESS_OVERVIEW}
                             isHistory={true}
                             type={DETAILS_VIEW_TYPE.PROCESS}
                             routerBlocker={props.blocker}
                             allowActionlessComments={taskDetails?.allowExtraComments}
                             addCommentHandler={dispatchHandleAddProcessAndHistoryDraftCommentsByUID}
                             getCommentsHandler={dispatchGetProcessAndHistoryComments}
                />
            }
        </div>
    );
}

export default TaskDetailMasterLayerByUID;
